import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
import moment from "moment";
import visionLogo from "../../images/vision-logo.png";
import { mergePdfs } from "../helpers/pdfs";
import { formatAmount } from "../helpers/common";

const generatePDF = async (buyingData, showPrice) => {
    const doc = new jsPDF('l', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 38;
    const leftX = 10;
    const rightX = pageWidth / 2 + 2;
    let currentY = margin;
    let isRightTable = false;
    let colX = leftX;
    let onePage = true;

    // Logo
    doc.addImage(visionLogo, "PNG", 8, 7, 44, 12);
    doc.setFontSize(16);
    doc.setFont("Outfit", "bold");
    doc.text("Buying Sheet - Vision", 285, 12, { align: "right" });

    doc.setFillColor(248, 248, 248);
    doc.rect(0, 22, pageWidth, 12, "F");

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Agent: ${buyingData.agentCode}`, 12, 30);
    doc.text(`Date: ${moment(buyingData.OrderDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}`, 280, 30, { align: "right" });
    doc.setTextColor("#252527");


    const products = buyingData?.products;
    let productsHead = [["Products", "Qty", "VP", "VP", "VP", "VP", "VP", "TTL", "Cnt", "Price"]];


    products.map((productTable) => {
        let ProductName = `${productTable.ProductName} ${productTable.ClassName || ''} ${productTable.SizeName || ''} ${productTable.UnitName || ''}`
        ProductName = ProductName?.replace(/\s+/g, ' ').trim();
        let tableRows = Object.values(productTable.customerGroups).reduce((count, groups) => count + groups.length, 0)
        tableRows = tableRows == 1 ? 2 : tableRows;
        let tableHeight = tableRows * 8;
        let isNotSpace = currentY + tableHeight > pageHeight - margin;

        // Check if there is enough space for this table
        if (isNotSpace && !isRightTable) {
            colX = rightX;
            currentY = onePage ? margin : 10;
            isRightTable = true;
        } else if (isNotSpace && isRightTable) {
            doc.addPage();
            colX = leftX;
            currentY = 10;
            isRightTable = false;
            onePage = false
        }

        let rows = [];
        Object.keys(productTable.customerGroups)?.map((key) => {
            let groupItems = productTable.customerGroups[key];
            groupItems.map((item) => {
                rows.push({
                    Qty: item[0]?.Qty,
                    VP1: item[0]?.BuyerCode.split('VP')[1] || item[0]?.BuyerCode || "",
                    VP2: item[1]?.BuyerCode.split('VP')[1] || item[1]?.BuyerCode || "",
                    VP3: item[2]?.BuyerCode.split('VP')[1] || item[2]?.BuyerCode || "",
                    VP4: item[3]?.BuyerCode.split('VP')[1] || item[3]?.BuyerCode || "",
                    VP5: item[4]?.BuyerCode.split('VP')[1] || item[4]?.BuyerCode || "",
                });
            })
        });

        let productBody = [[
            { content: ProductName, rowSpan: rows.length == 1 ? 2 : rows.length, styles: {fontStyle: "bold" }},
            { content: rows[0]?.Qty, styles: { halign: "center", fillColor: [242, 242, 242], fontStyle: "bold" } },
            { content: rows[0]?.VP1, styles: { halign: "center" } },
            { content: rows[0]?.VP2, styles: { halign: "center" } },
            { content: rows[0]?.VP3, styles: { halign: "center" } },
            { content: rows[0]?.VP4, styles: { halign: "center" } },
            { content: rows[0]?.VP5, styles: { halign: "center" } },
            { content: productTable?.TotalQty, rowSpan: rows.length == 1 ? 2 : rows.length, styles: { fillColor: [242, 242, 242], fontStyle: "bold" } },
            { content: productTable.Count, rowSpan: rows.length == 1 ? 2 : rows.length, styles: { paddingTop: "2px" } },
            { content: showPrice ? formatAmount(productTable.BuyPrice) : "" , rowSpan: rows.length == 1 ? 2 : rows.length, styles: { paddingTop: "2px" } }
        ]]
        rows.slice(1, rows.length)?.map((customer, index) => {
            productBody.push([
                { content: customer?.Qty, styles: { halign: "center", fillColor: [242, 242, 242], fontStyle: "bold" } },
                { content: rows[index + 1]?.VP1, styles: { halign: "center" } },
                { content: rows[index + 1]?.VP2, styles: { halign: "center" } },
                { content: rows[index + 1]?.VP3, styles: { halign: "center" } },
                { content: rows[index + 1]?.VP4, styles: { halign: "center" } },
                { content: rows[index + 1]?.VP5, styles: { halign: "center" } },
            ])
        });

        if (rows.length === 1) {
            productBody.push([
                { content: "-", styles: { halign: "center", fillColor: [242, 242, 242] } },
                { content: "", styles: { halign: "center" } },
                { content: "", styles: { halign: "center" } },
                { content: "", styles: { halign: "center" } },
                { content: "", styles: { halign: "center" } },
                { content: "", styles: { halign: "center" } },
            ]);
        }

        autoTable(doc, {
            startY: currentY,
            columnStyles: {
                0: { cellWidth: 35, halign: "center" },
                1: { cellWidth: 10, halign: "center" },
                2: { cellWidth: 10, halign: "center" },
                3: { cellWidth: 10, halign: "center" },
                4: { cellWidth: 10, halign: "center" },
                5: { cellWidth: 10, halign: "center" },
                6: { cellWidth: 10, halign: "center" },
                7: { cellWidth: 12, halign: "center" },
                8: { cellWidth: 12, halign: "center" },
                9: { cellWidth: 16, halign: "center" },
            },
            head: productsHead,
            body: productBody,
            theme: "grid",
            headStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                halign: "center",
                lineWidth: 0.2
            },
            styles: { fontSize: 10, textColor: "#000000" },
            margin: { top: 8, bottom: 8, left: colX, right: 7 },
        });

        currentY += tableHeight + 10;
    });

    // Footer Pagination
    const totalPageCount = doc.internal.pages.length - 1;

    for (let i = 1; i <= totalPageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor("#787a80")
        const currentDate = moment().format("DD MMMM, YYYY")
        const pageText = `Page ${i} of ${totalPageCount}`;
        const visionText = `VISION PRODUCE`;
        if (i === totalPageCount) {
            doc.setDrawColor(0);
            doc.setLineWidth(0.5);
            doc.line(10, doc.internal.pageSize.height - 10, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);
            doc.text(
                currentDate,
                doc.internal.pageSize.getWidth() - 285,
                doc.internal.pageSize.getHeight() - 5,
            );
            doc.text(
                visionText,
                doc.internal.pageSize.getWidth() - 160,
                doc.internal.pageSize.getHeight() - 5,
            );
        }
        doc.text(
            pageText,
            doc.internal.pageSize.getWidth() - 25,
            doc.internal.pageSize.getHeight() - 5,
        );
    }

    return doc.output("arraybuffer");
}

export const generateBuyingPdf = async (buyingDataArray, isEmail = false, showPrice = true) => {
    const pdfs = [];
    for (const ele of buyingDataArray) {
        const doc = await generatePDF(ele, showPrice);
        pdfs.push(doc);
    }
    
    const mergedPdf = await mergePdfs(pdfs);
    if (isEmail) {
        return mergedPdf;
    }
    const blob = new Blob([mergedPdf], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
}